/* eslint-disable no-restricted-syntax */

export const objectify = (
  items: Array<any>,
  key?: string | null | undefined,
) => {
  const actualKey = key || 'id';
  const dict: Record<string, any> = {};
  for (const item of items) {
    if (item && item[actualKey]) {
      dict[item[actualKey]] = item;
    }
  }
  return dict;
};

export const objectifyArrayOfArrays = (
  itemsArray: Array<Array<any>>,
  parentIDKey: string,
) => {
  const dict: Record<string, any> = {};
  for (const itemArray of itemsArray) {
    if (itemArray && itemArray.length > 0) {
      dict[itemArray[0][parentIDKey]] = objectify(itemArray);
    }
  }
  return dict;
};
